// @ts-nocheck
/* eslint-disable */
export const elioArrowIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 40 40"><defs><style>.arrow_svg__a{clip-path:url(#arrow_svg__b)}</style><clipPath id="arrow_svg__b"><rect width="40" height="40"/></clipPath></defs><g id="arrow_svg__a" class="arrow_svg__a"><path d="M16,4,13.885,6.115l8.37,8.385H4v3H22.255l-8.37,8.385L16,28,28,16Z" transform="translate(4 4)"/></g></svg>`,
    name: 'arrow' as const
};